import { queryOptions, useQuery } from "@tanstack/react-query";

import { baseInfo } from "./generated/admin";

export function baseInfoQueryOptions() {
  return queryOptions({
    queryKey: ["admin", "base-info"],
    // Keep the shared startup request alive across StrictMode's mount cycle.
    queryFn: () => baseInfo(),
    staleTime: Number.POSITIVE_INFINITY,
    retry: false,
    retryOnMount: false,
    refetchOnReconnect: false,
  });
}

export function useBaseInfoCache() {
  // The app entry owns fetching; pages only observe the shared cache.
  const { data } = useQuery({ ...baseInfoQueryOptions(), enabled: false });
  return data;
}
